var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPDownArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_6420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_6420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.75C10.9519 13.75 13.75 10.9519 13.75 7.5C13.75 4.04813 10.9519 1.25 7.5 1.25C4.04813 1.25 1.25 4.04813 1.25 7.5C1.25 10.9519 4.04813 13.75 7.5 13.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 6.5625L7.5 9.375L4.6875 6.5625",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_6420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15V15H0V0Z",
    fill: "#4E26A3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_6420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDownArrowCircle);
export default __webpack_public_path__ + "static/media/p_down_arrow_circle.bc37b703b821b621f51c4793bd958741.svg";
export { ForwardRef as ReactComponent };